import moment from 'moment';

export const calculateTotalPriceRelief = (startDate: string, endDate: string, startHour: number, endHour: number, price: number) => {
    const workHour = endHour - startHour;
    const diff = moment(endDate).diff(moment(startDate), 'days') || 1;
    return price * diff * workHour;
};
